import React from "react";
import Hero from "../components/Hero";
import ProofStrip from "../components/ProofStrip";
import Services from "../components/Services";
import Team from "../components/Team";
import Approach from "../components/Approach";
import Clients from "../components/Clients";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";

/** `/` in the final section order (spec c.7). Rendered inside SiteLayout. */
const Home: React.FC = () => (
  <>
    <Hero />
    <ProofStrip />
    <Services />
    <Team />
    <Approach />
    <Clients />
    <FAQ />
    <Contact />
  </>
);

export default Home;
